import { isAlexProxyActive } from '@shared/environment';
import { getFeatureConfig } from '@luna/feature-config';
import { getToken } from '@shared/auth';

const ALEX_PROXY_SESSION_TOKEN_PREFIX = 'GEORGE_PROXY_SESSION_';

export function getProxyCardTitle(): string {
    const { alexProxyVersion } = getFeatureConfig((config) => config);

    if (alexProxyVersion === 'v1') {
        return 'Alex proxy';
    }

    if (alexProxyVersion === 'v2') {
        return 'Dev proxy';
    }

    return '';
}

export function isReplayingAlexProxySession(): boolean {
    const accessToken = getToken();
    return accessToken.startsWith(ALEX_PROXY_SESSION_TOKEN_PREFIX);
}

export function isRecordingAlexProxySession(): boolean {
    return isAlexProxyActive() && !isReplayingAlexProxySession();
}
